import { useEffect } from "react";
import Swal from "sweetalert2";
import { SWAL_SETTINGS } from "../../../../utils/Constants";

export default function AppleLoginButton() {

    useEffect(() => {
        if (!window.AppleID) return;

        window.AppleID.auth.init({
            clientId: process.env.REACT_APP_APPLE_WEB_ID,
            scope: "name email",
            redirectURI: `${process.env.REACT_APP_SERVER_BASE_URL}/auth/apple/callback`, // ✅ FIXED
            usePopup: false, // redirect flow   
        });
    }, []);

    const handleAppleLogin = () => {
        try {
            window.AppleID.auth.signIn();
        } catch (error) {
            console.error("Apple login failed:", error);
            Swal.fire({
                icon: "error",
                text: "Apple login failed",
                ...SWAL_SETTINGS,
            });
        }
    };

    return (
        <button onClick={handleAppleLogin} type="button">
            <img src="/images/apple.svg" alt="Apple" />
        </button>
    );
}